"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConversationAssignmentEnum = void 0;
var ConversationAssignmentEnum;
(function (ConversationAssignmentEnum) {
    ConversationAssignmentEnum["OnOpen"] = "OnOpen";
    ConversationAssignmentEnum["OnReply"] = "OnReply";
    ConversationAssignmentEnum["OnClose"] = "OnClose";
    ConversationAssignmentEnum["Manually"] = "Manually";
})(ConversationAssignmentEnum = exports.ConversationAssignmentEnum || (exports.ConversationAssignmentEnum = {}));
